import { takeLatest, put, select, call } from 'redux-saga/effects'
import cookie from 'react-cookies'
import { getClient } from '@/store/selectors/socket'
import { SERVER_URL } from '@/constants/socket'
import { USER_PING } from '@/store/actions/user'
import {
  connectToSocket,
  setSocketSubscriptions,
} from '@/store/actions/socket'
import {
  successUserPing,
  errorUserPing,
} from '@/store/actions/user/userPing'
import { ACTIVE_PING_ITEM, ACCESS_TOKEN_COOKIE } from '@/constants/names'
import emitter from '@/helpers/eventEmitter'
import { refreshAccessToken, isRefreshRejected } from '@/helpers/axios/refreshAccessToken'

function sleep(sec) {
  return new Promise((resolve) => setTimeout(resolve, sec * 1000))
}

function removePingFromLS() {
  window.localStorage.setItem(ACTIVE_PING_ITEM, '0')
  emitter.emit(ACTIVE_PING_ITEM, 0)
}

function* resetLS(token) {
  while (true) {
    if (token === cookie.load(ACCESS_TOKEN_COOKIE)) {
      yield sleep(2)
      break
    }
    yield sleep(0.5)
  }
  removePingFromLS()
}

function* refreshAndReconnect() {
  const client = yield select(getClient)

  if (client && client.disconnect) {
    client.disconnect()
    yield put(setSocketSubscriptions({}))
  }

  const data = yield call(refreshAccessToken)
  const { access_token: accessToken } = data
  yield put(connectToSocket({
    url: SERVER_URL,
    token: accessToken,
  }))
  return accessToken
}

function* userPing() {
  try {
    if (!cookie.load(ACCESS_TOKEN_COOKIE)) {
      const refreshed = yield call(refreshAndReconnect)
      yield put(successUserPing())
      yield resetLS(refreshed)
      return null
    }

    window.localStorage.setItem(ACTIVE_PING_ITEM, '1')
    emitter.emit(ACTIVE_PING_ITEM, 1)

    let accessToken
    try {
      accessToken = yield call(refreshAndReconnect)
    } catch (firstError) {
      if (!isRefreshRejected(firstError) && !firstError.isRefreshRejected) {
        try {
          accessToken = yield call(refreshAndReconnect)
        } catch (retryError) {
          removePingFromLS()
          yield put(errorUserPing(retryError))
          return null
        }
      } else {
        removePingFromLS()
        yield put(errorUserPing(firstError))
        return null
      }
    }

    yield put(successUserPing())
    yield resetLS(accessToken)
    return null
  } catch (error) {
    removePingFromLS()
    yield put(errorUserPing(error))
    return null
  }
}

export default function* root() {
  yield takeLatest(USER_PING.REQUEST, userPing)
}
